import { API_GET_RAYONS_BY_GOROD_ID, MAIN_URL, PORT } from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { getRayon, getGorod, getCityByObl } from "../../../utilities";

export const exchangeCertificatesHeader = {
  // gridKey: "grid-container-republican",
  inputsOptions: {
    licenseTypeIdName: {
      key: "licenseTypeIdName",
      label: "Удостоверение типа",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
    },
    licenseNum: {
      key: "licenseNum",
      label: "Номер подлежащего обмену удостоверения на право управления прогулочным судном",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      buttonDisabled: true,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    licenseDate: {
      key: "licenseDate",
      label: "Дата подлежащего обмену удостоверения на право управления прогулочным судном",
      type: "date",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: true,
      required: false,
      needInForm: true,
    },
    exchangeReason: {
      key: "exchangeReason",
      label: "Причина обмена",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [
        {
          value: "1",
          label: "Истечение срока действия",
          key: "exchangeReason",
        },
        {
          value: "2",
          label: "Смена фамилии или имени",
          key: "exchangeReason",
        },
        {
          value: "3",
          label: "Установление неточности",
          key: "exchangeReason",
        },
      ],
      // customValidation(value, allValues) {
      //   if (value === "1") {
      //     if (allValues.licenseDateEnd) {
      //       const correctDate = allValues.licenseDateEnd.includes("-")
      //         ? allValues.licenseDateEnd
      //         : allValues.licenseDateEnd.split(".").reverse().join("-");
      //       if (new Date() >= new Date(correctDate).setMonth(new Date(correctDate).getMonth() - 6)) {
      //         return true;
      //       } else {
      //         return `Срок действия удостоверения истекает ${new Date(correctDate).toLocaleDateString()}`;
      //       }
      //     }
      //   } else return true;
      // },
    },
    validTypeName: {
      key: "validTypeName",
      label: "Вид прогулочного судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: false,
    },
    validZoneName: {
      key: "validZoneName",
      label: "Зона плавания",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: false,
    },
  },
};
export const interestedPersonRepublican = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-republican",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: true,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: true,
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    docSeries: {
      key: "docSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docNum: {
      key: "docNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 14,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    address: {
      key: "address",
      label: "Адрес",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      textarea: "textarea",
      required: true,
      needInForm: true,
      disabled: false,
    },
    birthDate: {
      key: "birthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: false,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    birthPlace: {
      key: "birthPlace",
      label: "Место рождения",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      placeholder: "Введите полное наименование страны",
    },
  },
};
export const interestedPersonInternational = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-international",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: true,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: true,
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    surnameEn: {
      key: "surnameEn",
      label: "Surname",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    nameEn: {
      key: "nameEn",
      label: "Name",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    docSeries: {
      key: "docSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docNum: {
      key: "docNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 14,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    address: {
      key: "address",
      label: "Адрес",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      textarea: "textarea",
      required: true,
      needInForm: true,
      disabled: false,
    },
    birthDate: {
      key: "birthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: false,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    addressEn: {
      key: "addressEn",
      label: "Address",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      textarea: "textarea",
      rows: 3,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    birthPlace: {
      key: "birthPlace",
      label: "Место рождения",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      placeholder: "Введите полное наименование страны",
      lang: "ru",
    },
    birthPlaceEn: {
      key: "birthPlaceEn",
      label: "Place of birth",
      type: "text",
      placeholder: "Введите полное наименование страны",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    residence: {
      key: "residence",
      label: "Гражданство",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      placeholder: "Введите полное наименование страны",
      lang: "ru",
    },
    residenceEn: {
      key: "residenceEn",
      label: "Residence",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
  },
};

export const representPerson = {
  caption: "Сведения о представителе заинтересованного лица",
  gridKey: "grid-container-represent",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    agentSurname: {
      key: "agentSurname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentName: {
      key: "agentName",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentMidname: {
      key: "agentMidname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentDocType: {
      key: "agentDocType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    agentDocSeries: {
      key: "agentDocSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[a-zA-Z]{2}$/,
        message: `Введите 2 латинские буквы`,
      },
    },
    agentDocNum: {
      key: "agentDocNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      maxLength: 7,
      upperCase: true,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    agentDocDate: {
      key: "agentDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    agentDocDepartment: {
      key: "agentDocDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPersNum: {
      key: "agentPersNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    agentCountry: {
      key: "agentCountry",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "Республика Беларусь",
    },
    agentOblastId: {
      key: "agentOblastId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentRayonId: {
      key: "agentRayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentGorodId: {
      key: "agentGorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentUlica: {
      key: "agentUlica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
    },
    agentDom: {
      key: "agentDom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
    },
    agentKorpus: {
      key: "agentKorpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentKv: {
      key: "agentKv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPhone: {
      key: "agentPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    agentDoverennost: {
      key: "agentDoverennost",
      label: "Сведения о доверенности",
      type: "text",
      textarea: true,
      rows: 3,
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
  },
};

export const infoMedicalConditions = {
  blockVisibility: true,
  inputsOptions: {
    medConditionsId: {
      key: "medConditionsId",
      label: "Медицинские показания",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [{ value: null, label: "—", key: "medConditionsId" }],
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export function setMedicalConditionOptions(lib) {
  if (lib.length > 0) {
    const validLib = lib.map((item) => {
      return {
        ...item,
        key: "medConditionsId",
      };
    });
    if (infoMedicalConditions.inputsOptions.medConditionsId.options.length === 1) {
      infoMedicalConditions.inputsOptions.medConditionsId.options.push(...validLib);
    }
  }
}

export function setGridsByMode(mode, typeId) {
  if (mode === "add") {
    representPerson.gridKey = "grid-container-represent";
    representPerson.inputsOptions.addressCaption.needInForm = false;
    representPerson.inputsOptions.personalDataCaption.needInForm = false;
  } else {
    representPerson.gridKey = "grid-container-represent-view";
    representPerson.inputsOptions.addressCaption.needInForm = true;
    representPerson.inputsOptions.personalDataCaption.needInForm = true;
  }
  return representPerson;
  // {
  //   header: exchangeCertificatesHeader,
  //   interested: interestedPersonRepublican,
  //   represent: representPerson,
  //   // training: datesDocOfTraining,
  //   // existingCertificate: infoAboutExistingCertificate,
  //   medCondition: infoMedicalConditions,
  // };
}
export async function setOptionsRepresentPerson(value, key) {
  if (Number(value[key]) === 5) {
    representPerson.inputsOptions.agentRayonId.options = [];
    representPerson.inputsOptions.agentRayonId.disabled = true;
    representPerson.inputsOptions.agentGorodId.options = [];
    representPerson.inputsOptions.agentGorodId.disabled = true;
    return representPerson;
  } else {
    switch (key) {
      case "agentOblastId": {
        const rayons = await getRayon(value[key]);
        const rayonsValid =
          rayons?.map((item) => {
            item.key = "agentRayonId";
            return item;
          }) || [];
        const cities = await getCityByObl(value[key]);
        const citiesValid =
          cities?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
        representPerson.inputsOptions.agentGorodId.options = citiesValid;
        representPerson.inputsOptions.agentGorodId.disabled = false;
        return representPerson;
      }
      case "agentRayonId": {
        const gorod = await getGorod(value[key]);
        const gorodValid =
          gorod?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentGorodId.options = gorodValid;
        representPerson.inputsOptions.agentGorodId.disabled = representPerson.inputsOptions.agentGorodId
          .options.length
          ? false
          : true;
        return representPerson;
      }
      case "agentGorodId": {
        // const selectedOptions = representPerson.inputsOptions.agentGorodId.options.find(
        //   (item) => value[key] === item.value,
        // );
        const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

        if (request.ok) {
          const response = await request.json();
          const rayonsValid =
            response?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                key: "agentRayonId",
              };
            }) || [];
          representPerson.inputsOptions.agentRayonId.options = rayonsValid;
          representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
            .options.length
            ? false
            : true;
        }
        return representPerson;
      }
      default:
        return representPerson;
    }
  }
}
export function setDocOptionsRepresentFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLibRepresent = docLib.map((item) => {
      return {
        ...item,
        key: "agentDocType",
      };
    });
    const validLibInterested = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (representPerson.inputsOptions.agentDocType.options.length === 0) {
      representPerson.inputsOptions.agentDocType.options.push(...validLibRepresent);
    }
    if (interestedPersonRepublican.inputsOptions.docType.options.length === 0) {
      interestedPersonRepublican.inputsOptions.docType.options.push(...validLibInterested);
    }
    if (interestedPersonInternational.inputsOptions.docType.options.length === 0) {
      interestedPersonInternational.inputsOptions.docType.options.push(...validLibInterested);
    }
  }
}

export function setOblOptionsFromDictionaries(oblLib) {
  const validLib = oblLib.map((item) => {
    return {
      ...item,
      key: "agentOblastId",
    };
  });
  if (representPerson.inputsOptions.agentOblastId.options.length === 0) {
    representPerson.inputsOptions.agentOblastId.options.push(...validLib);
  }
}

export function setDefaultOptionsRepresent(mode, visibilityKey, countryKey) {
  if (mode === "add") {
    representPerson.inputsOptions.agentCountry.defaultValue = "Республика Беларусь";
    representPerson.blockVisibility = true;
  } else {
    if (visibilityKey) {
      if (countryKey) {
        representPerson.inputsOptions.agentCountry.defaultValue = "Республика Беларусь";
      } else {
        representPerson.inputsOptions.agentCountry.defaultValue = "";
      }
    } else {
      representPerson.blockVisibility = false;
    }
  }
  return representPerson;
}

export const setHeaderFieldsByCertificateType = (typeId) => {
  if (Number(typeId) === 1) {
    exchangeCertificatesHeader.inputsOptions.validTypeName.needInForm = false;
    exchangeCertificatesHeader.inputsOptions.validZoneName.needInForm = false;
  } else {
    exchangeCertificatesHeader.inputsOptions.validTypeName.needInForm = true;
    exchangeCertificatesHeader.inputsOptions.validZoneName.needInForm = true;
  }
  return exchangeCertificatesHeader;
};

export const setDisabledButtonStatus = (value, typeId) => {
  if (value) {
    if (/^[0-9]+[0-9]*$/.test(value)) {
      exchangeCertificatesHeader.inputsOptions.licenseNum.buttonDisabled = false;
    } else {
      exchangeCertificatesHeader.inputsOptions.licenseNum.buttonDisabled = true;
    }
  } else {
    exchangeCertificatesHeader.inputsOptions.licenseNum.buttonDisabled = true;
  }
  return {
    header: exchangeCertificatesHeader,
    interested: typeId === 1 ? interestedPersonRepublican : interestedPersonInternational,
    represent: representPerson,
    medCondition: infoMedicalConditions,
  };
};
